<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-10-16 09:26:51
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-11-17 14:21:35
 -->
<!--  -->
<template>
<div class="easyCrud avue-crud">
    <el-card v-if="tableInfo" shadow="hover" body-style="padding:0px 15px  10px 15px ;">
        <!-- start::表头 -->
        <div v-if="tableInfo.header && (tableInfo.header.title || tableInfo.header.slotName)" slot="header" class="easyCrud_head">
          <slot v-if="tableInfo.header.slotName" :name="tableInfo.header.slotName"></slot>
          <template v-else>
            <i v-if="tableInfo.header.needIcon !== false" :class="(tableInfo.header.icon?tableInfo.header.icon: 'fa fa-table') + ' easyCrud_head_icon'" />
            <span v-if="tableInfo.header.title" class="easyCrud_head_title"> {{tableInfo.header.title}}</span>
          </template>
        </div>
        <!-- end::表头 -->
         <el-collapse-transition>
            <!-- start::条件筛选 -->
            <el-row v-if="searchShowFlag"  :gutter="2" >
                <el-form   v-if=" getConditionColumn().length !==0"   :label-width=" tableInfo.table.conditionLabelWidth || '100px'" :inline="false"  label-suffix=":" >
                    <el-col v-for="(item,index)  in getConditionColumn()" :key="index"  :xl="tableInfo.table.xl || 6" :lg="tableInfo.table.lg || 8" :md="tableInfo.table.md || 12" :sm="tableInfo.table.sm || 12"  :xs="24">
                        <el-form-item  :label="item.label||'未命名字段'" >
                            <component
                            :is="getComponent(item.type, item.component)"
                            :change="resetCurrentPage"
                            :dataType="item.dataType"
                            :clearable="item.clearable"
                            :format="item.format"
                            :multiple="item.multiple"
                            :label="item.label"
                            :minRows="item.minRows"
                            :maxRows="item.maxRows"
                            :precision="item.precision"
                            :prop="item.prop"
                            :placeholder="getPlaceholder(item)"
                            :tip="item.tip"
                            :type=" getType(item.type)"
                            :display="item.display"
                            :valueDefault="item.valueDefault"
                            :tags='true'
                            :value-format="item.valueFormat"
                            :min="item.min"
                            :max="item.max"
                            :minlength="item.minlength"
                            :maxlength="item.maxlength"
                            size="medium"
                            :append="item.append"
                            :dic="item.dicData"
                            :border="item.border"
                            :prepend="item.prepend"
                            :showWordLimit="item.showWordLimit"
                            :controls-position="item.controlsPosition"
                            v-model="tableInfo.table.reloadConditions[item.prop]"
                            />
                        </el-form-item >
                         <template v-if="tableInfo.buttonSetting && tableInfo.buttonSetting.searchSlotName" slot-scope="scope">
                             <!-- 如果该列配置中 slot 为true  向外给出插槽-->
                            <slot   :data="tableInfo.table.reloadConditions" :name="tableInfo.buttonSetting.searchSlotName"></slot>
                         </template>
                    </el-col>
                    <el-col :xl="tableInfo.table.xl || 12" :lg="tableInfo.table.lg || 16" :md="tableInfo.table.md || 12" :sm="tableInfo.table.sm || 12"  :xs="24">
                        <el-form-item  >
                            <el-button @click="reload" type="primary" icon="el-icon-search"  size="small">搜索</el-button>
                            <el-button @click="resetForm" icon="el-icon-delete"  size="small">清空</el-button>
                        </el-form-item>
                    </el-col>
                </el-form>
            </el-row>
        </el-collapse-transition>
        <!-- end::条件筛选 -->
        <div class="avue-crud__menu" v-if="tableInfo.buttonSetting && (tableInfo.buttonSetting.allowAdd ||tableInfo.buttonSetting.allowDelete ||( tableInfo.buttonSetting.left && tableInfo.buttonSetting.left.length ) ||(tableInfo.buttonSetting.right && tableInfo.buttonSetting.right.length) )">
            <div class="avue-crud__left">
                <el-button v-if="tableInfo.buttonSetting.allowAdd  !==  false" icon="el-icon-plus"   type="primary" size="small" @click="addRow"> 新增 </el-button>
                <el-button v-if="tableInfo.buttonSetting.allowDelete !==false && tableInfo.buttonSetting.allowMoreDelete !==false" icon="el-icon-delete" type="danger"  size="small" @click="deleteRows()"> 删除 </el-button>
                <template v-if="tableInfo.buttonSetting.left && tableInfo.buttonSetting.left.length">
                    <el-button v-for="(item,index) in  tableInfo.buttonSetting.left"  :key="index" :type="item.type||'primary'" :icon="item.icon" size="small" @click="triggerEvent(item.clickEvent)"> {{item.title||'未命名按钮'}} </el-button>
                </template>
            </div>
            <div class="avue-crud__right">
                <el-tooltip  effect="light" content="刷新" placement="bottom">
                    <el-button v-if="tableInfo.buttonSetting.allowRefresh === false ? false:true" @click="reload" icon="el-icon-refresh"   size="small" circle></el-button>
                </el-tooltip>
                <el-tooltip  effect="light" content="搜索" placement="bottom">
                    <el-button @click="searchShow" v-if="getConditionColumn().length !==0" icon="el-icon-search" size="small" circle></el-button>
                </el-tooltip>
                <template v-if="tableInfo.buttonSetting.right && tableInfo.buttonSetting.right.length">
                   <el-tooltip v-for="(item,index) in  tableInfo.buttonSetting.right"  :key="index" effect="light" :content="item.title" placement="bottom">
                       <el-button  :type="item.type||'primary'" circle :icon="item.icon" size="small" @click="triggerEvent(item.clickEvent)">  </el-button>
                    </el-tooltip>
                </template>

            </div>
        </div>
          <!-- start::表单数据渲染区域 -->
      <el-table
        v-if="tableInfo.table"
        :row-key="getRowKeys"
        :lazy=true
        :load="load"
        ref="table"
        size='medium'
        @sort-change="sortChange"
        tooltip-effect="light"
        :row-style="tableInfo.table.rowStyle"
        v-loading="tableInfo.table.loadings"
        element-loading-text="拼命加载中..."
        :stripe="tableInfo.table.stripe"
        :highlight-current-row="true"
        :data="tableInfo.table.tableData"
        :height="tableInfo.table.height"
        :max-height="tableInfo.table.maxHeight||tableInfo.table.height||500"
        border
        @select="getSelect"
      >
      <template slot="empty">
          <avue-empty></avue-empty>
      </template>
      <!-- 多选列 -->
        <el-table-column v-if="tableInfo.table.selection !== false " align="center"  fixed="left" width="50" type="selection" prop="rowid" ></el-table-column>
        <el-table-column v-if="tableInfo.table.index !== true " align="center" fixed="left" width="50" label="#" type="index" ></el-table-column>
        <template v-if="tableInfo.table.columns && tableInfo.table.columns.length >0" >
          <template  v-for="(item,index) in tableInfo.table.columns">
            <el-table-column
              :key="index"
              v-if="item.showInTable === false ?false:true"
              :align="item.align || 'center'"
              :header-align="tableInfo.table.headerAlign || 'center'"
              show-overflow-tooltip
              :prop="item.prop"
              :label="item.label"
              :fixed="item.fixed"
              :sortable="item.sortable"
              :width="item.width"
            >
            <template slot-scope="scope">
                  <!-- 如果该列配置中 slot 为true  向外给出插槽-->
                  <slot v-if="item.slotName"  :row="scope.row" :name="item.slotName"></slot>
                  <template v-else>
                      <el-tag
                      v-if="item.isTag"
                      :type="typeof item.tagFilter === 'function'?item.tagFilter(scope.row[item.prop],scope.row).type:''"
                      >
                      {{ typeof item.tagFilter === 'function'?item.tagFilter(scope.row[item.prop],scope.row).data:scope.row[item.prop] }}
                      </el-tag>
                      <template v-else>
                          {{typeof item.dataFilter === 'function'?item.dataFilter(scope.row[item.prop],scope.row):scope.row[item.prop]}}
                      </template>
                  </template>
            </template>
          </el-table-column>
          </template>
        </template>
        <!-- note::循环操作 -->
        <el-table-column
          :align="tableInfo.table.center || 'center'"
          fixed="right"
          label="操作"
          v-if="(tableInfo.table.operation && tableInfo.table.operation.operations && tableInfo.table.operation.operations.length!=0)
          || (tableInfo.table.operation && tableInfo.table.operation.slotName)
          || tableInfo.buttonSetting.allowView !==false
          || tableInfo.buttonSetting.allowEdit !==false
          ||tableInfo.buttonSetting.allowDelete !==false"
          :width="tableInfo.table.operation && tableInfo.table.operation.width ? tableInfo.table.operation.width : '' "
        >
          <template slot-scope="scope">
              <!-- 如果操作列需要插槽展示,这里变对外抛出插槽 -->
              <slot v-if="tableInfo.table.operation && tableInfo.table.operation.slotName" :name="tableInfo.table.operation.slotName" :row="scope.row"></slot>
             <template v-else>
               <el-button size="small" v-if="tableInfo.buttonSetting.allowView !==false " type="text" @click="viewRow(scope.row)">
                    <span >查看</span>
                </el-button>
                <el-button  size="small" v-if="tableInfo.buttonSetting.allowEdit !==false " type="text" @click="editRow(scope.row)">
                    <span style="color:#9f8bea">编辑</span>
                </el-button>
                <el-button size="small" v-if="tableInfo.buttonSetting.allowDelete !==false " type="text" @click="deleteRows(scope.row)">
                    <span style="color:#e78ab0">删除</span>
                </el-button>
                <!-- 开始循环自定义的操作 -->
                <template v-if="tableInfo.table.operation && tableInfo.table.operation.operations && tableInfo.table.operation.operations.length!=0">
                  <el-button  size="small"
                      v-for="(item,index) in tableInfo.table.operation.operations"
                      :key="index"
                      type="text"
                      @click="triggerEvent(item.clickEvent,scope.$index, scope.row)"
                      >
                      <span :style="{color:item.color}">{{ typeof item.title === 'function'?item.title(scope.row):item.title }}</span>
                  </el-button>
              </template>
             </template>
          </template>
        </el-table-column>
      </el-table>
      <nav v-if="tableInfo.table && tableInfo.table.paging"  style="text-align: center;margin:10px 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="tableInfo.table.paging.currentPage || 1"
          :page-sizes="tableInfo.table.paging.pageSizes || [15, 25, 35, 45]"
          :page-size="tableInfo.table.paging.pageSize || 15"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableInfo.table.paging.total || 0 "
        ></el-pagination>
      </nav>
    </el-card>
     <!-- 以下是新增,编辑,查看 显示框 -->

</div>
</template>

<script>

export default {
  data() {
    return {
      searchShowFlag: true

    }
  },

  props: {
    'tableInfo': {
      type: Object,
      validator: function(tableInfo) {
        if (!tableInfo) {
          console.log('easyCrud组件异常', '组件需要 tableInfo 参数才能正常渲染', 'warning')
          return false
        }
        if (!tableInfo.buttonSetting) {
          console.log('easyCrud组件异常', '组件需要 tableInfo.buttonSetting 参数才能正常渲染,默认配置请置为{}', 'warning')
          return false
        }
        if (!tableInfo.table) {
          console.log('easyCrud组件异常', '组件需要 tableInfo.table 参数才能正常渲染。', 'warning')
          return false
        }
        if (!tableInfo.table.reloadConditions) {
          console.log('easyCrud组件异常', '请将tableInfo.table.reloadConditions 置为{}。', 'warning')
          return false
        }
        if (!tableInfo.table.addDefultValue) {
          console.log('easyCrud组件异常', '请将tableInfo.table.addDefultValue 置为{}。', 'warning')
          return false
        }
        return true
      }
    }
  },

  components: { },

  methods: {
    getSelect(selection, row) {
      console.log('row')
      console.log(row)
      console.log(selection)
      this.$emit('getSelected', selection, row)
    },
    getRowKeys(row) {
      return row.id
    },

    /** 新增的保存按钮触发函数 触发到根组件*/
    addRowInternalFunction: function(rowData) {
      /** 保存按钮转圈 */
      this.easyFormInfoAddRow.formButton[0].loading = true
      this.triggerEvent(this.tableInfo.buttonSetting.addFunctionName || 'addRow', rowData, () => {
        this.easyFormInfoAddRow.header.show = false
        this.easyFormInfoAddRow.formButton.forEach(item => (item.loading = false))
      }, () => {
        this.easyFormInfoAddRow.formButton.forEach(item => (item.loading = false))
      }, 'ADD')
    },
    /** 编辑某行 */
    editRow: function(row) {
      var callback = (data) => {
        this.easyFormInfoEditRow.header.show = true
        this.easyFormInfoEditRow.formButton.forEach(item => (item.loading = false))
        this.easyFormInfoEditRow.data = data || this.deepClone(row)
        if (this.easyFormInfoEditRow.form.formItems.length !== 0) {
          return
        }
        if (this.tableInfo.buttonSetting.editbuttonArray && this.tableInfo.buttonSetting.editbuttonArray.length) {
          this.tableInfo.buttonSetting.editbuttonArray.forEach(item => {
            if (!item.note) {
              item.note = {}
            }
            /** 将 clickEvent 转到node值上 */
            item.note.clickEvent = item.clickEvent
            item.note.scene = 'EDIT'
            /** 使用父组件 triggerEvent 函数，继续向外抛出事件*/
            item.clickEvent = 'unifiedCaptureFunction'
            this.easyFormInfoEditRow.formButton.push(item)
          })
        }
        let columns = this.deepClone(this.tableInfo.table.columns)
        columns.forEach((item, index) => {
        /** 是否显示 */
          if (item.view && item.view.length === 3 ? item.view[2] : true) {
            item.disabled = item.disabled && item.disabled.length === 3 ? item.disabled[2] : false
            this.easyFormInfoEditRow.form.formItems.push(item)
          }
        })
      }
      if (this.tableInfo.buttonSetting.beforeEditFunctionName) {
        this.triggerEvent(this.tableInfo.buttonSetting.beforeEditFunctionName, this.deepClone(row), 'EDIT', callback)
      } else {
        callback()
      }
    },
    /** 编辑的保存按钮触发函数 触发到根组件*/
    editRowInternalFunction: function(rowData) {
      this.easyFormInfoEditRow.formButton[0].loading = true
      this.triggerEvent(this.tableInfo.buttonSetting.editFunctionName || 'editRow', rowData, () => {
        this.easyFormInfoEditRow.header.show = false
        this.easyFormInfoEditRow.formButton.forEach(item => (item.loading = false))
      }, () => {
        this.easyFormInfoEditRow.formButton.forEach(item => (item.loading = false))
      }, 'EDIT')
    },
    /** 查看某一行数据 */
    viewRow: function(row) {
      var callback = (data) => {
        this.easyFormInfoViewRow.header.show = true
        this.easyFormInfoViewRow.formButton.forEach(item => (item.loading = false))
        this.easyFormInfoViewRow.data = data || this.deepClone(row)
        if (this.easyFormInfoViewRow.form.formItems.length !== 0) {
          return
        }
        if (this.tableInfo.buttonSetting.viewbuttonArray && this.tableInfo.buttonSetting.viewbuttonArray.length) {
          this.tableInfo.buttonSetting.viewbuttonArray.forEach(item => {
            if (!item.note) {
              item.note = {}
            }
            /** 将 clickEvent 转到node值上 */
            item.note.clickEvent = item.clickEvent
            item.note.scene = 'VIEW'
            /** 使用父组件 triggerEvent 函数，继续向外抛出事件*/
            item.clickEvent = 'unifiedCaptureFunction'
            this.easyFormInfoViewRow.formButton.push(item)
          })
        }
        let columns = this.deepClone(this.tableInfo.table.columns)
        columns.forEach((item, index) => {
        /** 是否显示 */
          if (item.view && item.view.length === 3 ? item.view[1] : true) {
            item.disabled = item.disabled && item.disabled.length === 3 ? item.disabled[1] : true
            this.easyFormInfoViewRow.form.formItems.push(item)
          }
        })
      }
      if (this.tableInfo.buttonSetting.beforeViewFunctionName) {
        this.triggerEvent(this.tableInfo.buttonSetting.beforeViewFunctionName, this.deepClone(row), 'VIEW', callback)
      } else {
        callback()
      }
    },
    /**
     * 删除函数
     */
    deleteRows: function(row, index) {
      var deleteList = []
      /** 判断是多行删除还是单行删除 */
      if (row) {
        deleteList.push(row)
      } else {
        deleteList = this.getSelectedRows()
        if (deleteList.length === 0) {
          return this.$message({ message: '请选中一条记录再操作哟。', type: 'warning' })
        }
      }
      /** 开始执行删除    **  先询问 */
      this.$confirm('删除后不可恢复, 是否继续?', '提示', { cancelButtonText: '取消', confirmButtonText: '确定', type: 'warning' }).then(() => {
        this.triggerEvent(this.tableInfo.buttonSetting.deleteFunctionName || 'deleteRows', deleteList, index)
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消删除' })
      })
    },
    /** 父组件事件触发器  默认4参数  x为事件 */
    triggerEvent: function(x, y, z, a, b) {
      this.$emit(x, y, z, a, b)
    },
    /** 重置表格筛选函数 */
    resetForm: function() {
      /** 清除表格条件 */
      this.tableInfo.table.reloadConditions = {}
      /** 修改当前页码*/
      this.resetCurrentPage(null, 'system')
    },
    /**
     * @description 从表格配置中,提取出允许作为搜索条件的元素
     */
    getConditionColumn() {
      if (!this.ConditionColumn) {
        this.ConditionColumn = this.tableInfo.table.columns.filter(i => i.isSearchCondition === true)
      }
      return this.ConditionColumn
    },
    /**
     * @description 返回表格中选中状态的数据,为避免异常发生,如果获取到为空,则返回空数组
     */
    getSelectedRows: function() {
      return this.$refs.table.selection || []
    },
    /**
     * @description 单击某行数据触发的函数,如果该行lable不为“操作”,则选中该行
     */
    /* clickRow(row, event, column) {
      console.log('clickRow')
      console.log(row)
      this.$emit("getSelected",row)
      event.label !== '操作' && this.$refs.table.toggleRowSelection(row)
    },*/
    /**
    * @description 获取配置项中columnName列的setingName的配置
    * @param {String} columnName 列名称(prop)
    * @param {String} setingName 配置项名称
    */
    getColumnSeting: function(columnName, setingName) {
      let temp = this.tableInfo.table.columns.filter(item => item.prop === columnName)
      return temp.length === 1 ? temp[0][setingName] : { warning: '执行错误,未找到或找到多个:' + columnName }
    },
    /**
    * @description 设置配置项中columnName列的setingName属性为steingValue
    * @param {String} columnName 列名称(prop)
    * @param {String} setingName 配置项名称
    * @param {Object} steingValue 配置的数据
    */
    setColumnSeting: function(columnName, setingName, steingValue) {
      let temp = this.tableInfo.table.columns.filter(item => item.prop === columnName)
      return temp.length === 1 ? this.$set(temp[0], setingName, steingValue) : { warning: '执行错误,未找到或找到多个:' + columnName }
    },
    /**
     * @description 在重载条件改变后,需要重置当前页.避免请求数据时,请求页数超最大页.
     */
    resetCurrentPage: function(data, system) {
      if ((data && data.value !== undefined) || system) {
        this.tableInfo.table.paging && this.tableInfo.table.paging.currentPage && (this.tableInfo.table.paging.currentPage = 1)
      }
    },
    /** 排序改变事件 */
    sortChange: function({ column, prop, order }) {
      this.tableInfo.table['serverSort'] = {}
      if (this.getColumnSeting(prop, 'serverSort') === true) {
        this.tableInfo.table['serverSort']['sidx'] = prop
        this.tableInfo.table['serverSort']['sord'] = order
        this.reload()
      }
    },
    /**
     * @description 页大小改变后触发该事件
     * @param {number} pageSize 改变后的页大小
     */
    handleSizeChange: function(pageSize) {
      this.tableInfo.table && (this.tableInfo.table.paging['pageSize'] = pageSize) && this.reload()
    },
    /**
     * @description 页改变后触发该事件
     * @param {number} currentPage 改变后的页
     */
    handleCurrentChange: function(currentPage) {
      this.tableInfo.table && (this.tableInfo.table.paging['currentPage'] = currentPage) && this.reload()
    },
    /**
     * @description 获取重载条件,重载表中数据
     */
    reload: function() {
      this.$emit(this.tableInfo.table.reload, this.getReloadConditions())
    },
    /** 获取表格重载条件  2019-10-17 第 { 7 } 次重构 */
    getReloadConditions: function() {
      let reloadConditions = this.tableInfo.table.reloadConditions
      let retult = {}
      for (let conditionItem in reloadConditions) {
        let item = reloadConditions[conditionItem]
        if (item || item === 0 || item === false) {
          retult[conditionItem] = item
        }
      }
      /** 在存在 paging 且 paging 合法 的情况下 获取 paging 条件集合 */
      if (
        this.tableInfo.table.paging &&
        this.tableInfo.table.paging.currentPage &&
        this.tableInfo.table.paging.pageSize
      ) {
        retult['pageNum'] = this.tableInfo.table.paging.currentPage
        retult['pageSize'] = this.tableInfo.table.paging.pageSize
      }
      /** 获取tableInfo 中 serverSort 字段。 */
      if (
        this.tableInfo.table['serverSort'] &&
        this.tableInfo.table['serverSort'].sidx &&
        this.tableInfo.table['serverSort'].sord
      ) {
        retult['sidx'] = this.tableInfo.table['serverSort'].sidx
        retult['sord'] = this.tableInfo.table['serverSort'].sord
      }
      return retult
    },
    /**
     * @description 根据字段类型或组件名称,返回应加载的组件名称
     * @param {string} type 类型
     * @param {string} component 组建名
     */
    getComponent: function(type, component) {
      let KEY_COMPONENT_NAME = 'avue-'
      let result = 'input'
      if (!this.validatenull(component)) {
        return component
      } else if (type === 'select') {
        result = 'select'
      } else if (type === 'radio') {
        result = 'radio'
      } else if (type === 'checkbox') {
        result = 'checkbox'
      } else if (['time', 'timerange'].includes(type)) {
        result = 'time'
      } else if (
        [
          'dates',
          'date',
          'datetime',
          'datetimerange',
          'daterange',
          'week',
          'month',
          'year'
        ].includes(type)
      ) {
        result = 'date'
      } else if (type === 'number') {
        result = 'input-number'
      } else if (type === 'password') {
        result = 'input'
      } else if (type === 'switch') {
        result = 'switch'
      } else if (type === 'rate') {
        result = 'rate'
      } else if (type === 'slider') {
        result = 'slider'
      } else if (type === 'color') {
        result = 'color'
      }
      return KEY_COMPONENT_NAME + result
    },
    /**
     * @description 获取提示字符串
     * @param {Object} column 列配置
     */
    getPlaceholder(column) {
      if (column.placeholder) {
        return column.placeholder
      }
      const label = column.label
      if (['select', 'checkbox', 'radio', 'color', 'date', 'time'].includes(column.type)) {
        return `请选择${label}`
      } else {
        return `请输入${label}`
      }
    },
    getType: function(type) {
      if (type === 'textarea') {
        return 'input'
      } else {
        return type
      }
    },
    /**
     * 隐藏显示搜索条件
     */
    searchShow: function() {
      this.searchShowFlag = !this.searchShowFlag
    },
    /**
     * 表格扩展按钮处理函数 此处考虑还是向外给出 done errDone 函数
     * @parms  data  表单数据
     * @parms  note  备注值，该处可能直接为事件
     */
    unifiedCaptureFunction: function(data, note) {
      let tempData
      note.scene === 'ADD' ? tempData = this.easyFormInfoAddRow : note.scene === 'EDIT' ? tempData = this.easyFormInfoEditRow : tempData = this.easyFormInfoViewRow
      tempData.formButton.forEach(item => (item.loading = true))
      this.$emit(note.clickEvent, data, note.scene, () => {
        tempData.header.show = false
        tempData.formButton.forEach(item => (item.loading = false))
      }, () => {
        tempData.formButton.forEach(item => (item.loading = false))
      })
    },
    load: function(tree, treeNode, resolve) {
      this.triggerEvent('load', tree, treeNode, resolve)
    }
  }
}
</script>
<style lang='scss'>
.easyCrud {
    .el-card__header {
        padding: 15px 20px;
    }
    .el-form-item {
        margin: 8px 10px 0px 0px;
    }
    .el-col{
      margin-bottom: 0px;
    }
    /** 修改树形表格的图标  */
  /*.el-table__expand-icon{
  border: solid red 1px;
   -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  .el-icon-arrow-right:before{
   content: "\e601";
    font-size: 18px;
  }
}*/
}
</style>
<style lang='scss' scoped>
.easyCrud {
    &_head {
        &_icon {
            color: #409EFF
        }
        &_title {
            text-indent: 2px;
            color: #409EFF;
        }
    }
}
.avue-crud__menu{
    margin-top: 5px;
}
.avue-crud__left ,.avue-crud__right{
    line-height: 40px;
}

</style>
